import React from 'react';
import Link from 'gatsby-link';

const IndexPage = () => (
  <div>
    <article id="summary-about">
      <h1>Web Architect</h1>
      <p>Design/Architect web solutions for modern web applications</p>

      <h2><strong>Usability</strong> <em>Expert</em></h2>
      <p>Simple and functional user experiences. (UI / UX)</p>

      <h2><strong>Code</strong> <em>Engineer</em></h2>
      <p>Semantic, well-structured and efficient code. (Front-end and Back-end)</p>

      <h2><strong>WebOps</strong> <em>Engineer</em></h2>
      <p>Reliable, scalable and secure platform with automated code integration/deployment.</p>
    </article>

    <article id="featured-portfolio">
      <h1>Recent Work</h1>
      <section>
        <header>
          <h2>Work Title</h2>
        </header>
        <img src="" alt="work title" />
        <p className="description">Lorem ipsum dolor sit amet, repudiare euripidis cu vis, ei nec dicta animal. Ad utroque mediocritatem ius, sed primis detracto cu. Nec cu eius pericula ocurreret, quo ei putent officiis mediocritatem.</p>
      </section>
    </article>

    <article id="latest-blog">
      <h1>Latest Post</h1>
      <section>
        <header>
          <h2>Blog post title</h2>
        </header>
        <img src="" alt="blog post title" />
        <p className="description">Duo stet debitis ad, partem aliquando conclusionemque sed in. Qui offendit appareat petentium cu, vis no aeque persius.</p>
      </section>
    </article>

    <article id="direct-contact">
      <h1>Let's Chat</h1>
      <p>click to copy my email address to your clipboard</p> 
    </article>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js